import { render, staticRenderFns } from "./ModalSelectDoctorsWS.vue?vue&type=template&id=918dedd2&scoped=true"
import script from "./ModalSelectDoctorsWS.vue?vue&type=script&lang=js"
export * from "./ModalSelectDoctorsWS.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectDoctorsWS.vue?vue&type=style&index=0&id=918dedd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918dedd2",
  null
  
)

export default component.exports